import React, {useState,useEffect} from "react";
import {mrbgStore, redFldToWhite, setSundryField} from './mrbgRedux';

function MrbgRadioInput({formID,name,values,other,storeInRedux,formStyle}){

  const
    [allVal,setAllVal] = useState( typeof values=='string'? mrbgStore.getState().mrbgVars[values]: values ),
    [formsSettings,setFormsSettings] = useState( mrbgStore.getState().formsSettings[formID] ),
    [curVal,setCurVal] = useState( null );

  function changeInpVal(val){
    mrbgStore.dispatch(redFldToWhite({formID,name}));
    setCurVal(val)
  }

  useEffect(()=>{
    if( storeInRedux )
      mrbgStore.dispatch( setSundryField({formID,fieldName:name,fieldValue:curVal}) )
  },[curVal])
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setFormsSettings(mrbgStore.getState().formsSettings[formID])
      setAllVal( typeof values=='string'? mrbgStore.getState().mrbgVars[values]: values )
    })
    return () =>unsubscribe();
  },[]);

  return(
    <div className={`${formStyle.itemFrame}${formsSettings?.redFld?.includes(name)? ' '+formStyle.emptyField: ''}`} data-si={storeInRedux?true:false}>
      {
        Object.keys(allVal).map((inputVal,key)=>{
          const id = 'NR_'+formID+name.substring(0,1).toUpperCase()+name.substring(1)+key;
          return(
            <React.Fragment key={key}>
              <input type="radio" name={name} className={formStyle.mrbgRadioInput} value={inputVal} {...other} disabled={formsSettings?.disabled?.includes(name)? true:false} id={id} onChange={e=>changeInpVal(e.target.value)}/>
              <label htmlFor={id} tabIndex={0} onKeyUp={e=>{if(e.keyCode==13)document.getElementById(id).checked=true}}>
                {allVal[inputVal]}
                <i className="fa-regular fa-square fa-2x"></i>
                <i className="fa-regular fa-square-check fa-2x"></i>
              </label>
            </React.Fragment>
          )
        })
      }
    </div>
  )
}
export default MrbgRadioInput;